import actions from "./actions";

const initState = {
    miniPosOrderReadState: false,
    miniPosOrderReadStateErrorMessage: null,
    order: {},
    company: {},
    contact: {},
    miniPosOrderMyInvoisValid: null,

    orderRequestEInvoiceState: false,
    orderRequestEInvoiceResult: null,
    orderRequestEInvoiceResultMessage: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.PUBLIC_MINIPOS_ORDER_READ_REQUEST:
            return {
                ...state,
                miniPosOrderReadState: 'request',
            };
        case actions.PUBLIC_MINIPOS_ORDER_READ_SUCCESS:
            return {
                ...state,
                miniPosOrderReadState: 'success',
                order: action.order || {},
                company: action.company || {},
                contact: action.contact || {},
                miniPosOrderMyInvoisValid: action.is_order_myinvois_valid,
            };
        case actions.PUBLIC_MINIPOS_ORDER_READ_ERROR: {
            if (action.error.statusCode === 403) {
                return {
                    ...state,
                    miniPosOrderReadState: 'error',
                    eInvoiceNotSubscribed: true,
                };
            }
            return {
                ...state,
                miniPosOrderReadState: 'error',
                miniPosOrderReadStateErrorMessage: action.errorMessage,
            };
        }

        case actions.PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_REQUEST:
            return {
                ...state,
                orderRequestEInvoiceState: 'request',
            };
        case actions.PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_SUCCESS:
            return {
                ...state,
                orderRequestEInvoiceState: 'success',
                orderRequestEInvoiceResult: action.status,
                orderRequestEInvoiceResultMessage: action.message,
            };
        case actions.PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_ERROR:
            return {
                ...state,
                orderRequestEInvoiceState: 'error',
            };
        default:
            return state;
    }
}
